<template>
  <div id="app_header">
    <div class="bg_img content_width"></div>
    <div class="nav_tabs_bg">
      <el-menu :default-active="activeIndex" class="nav_tabs content_width" mode="horizontal" background-color="#545c64" text-color="#fff" active-text-color="#67C23A" :router="true">
        <el-menu-item index="/"> 首页 </el-menu-item>
        <el-menu-item index="/about"> 关于我们 </el-menu-item>
        <el-menu-item index="/contact"> 联系我们 </el-menu-item>
        <el-menu-item index="/privacy"> 隐私政策 </el-menu-item>
        <el-menu-item index="/clause"> 条款 </el-menu-item>
        <!-- <el-menu-item index="/mobile">二次元</el-menu-item> -->
        <!-- <el-menu-item index="/webpageGame">模拟经营</el-menu-item> -->
        <!-- <el-menu-item index="/aloneGame">单机</el-menu-item> -->
        <!-- <el-menu-item index="/develop">放置</el-menu-item> -->
        <!-- <el-menu-item index="/adventure">Roguelike</el-menu-item> -->
        <!-- <el-menu-item index="/recruit">招聘</el-menu-item> -->
      </el-menu>
    </div>


  </div>
</template>

<script>
export default {
    name: "Header",
    components: {
        // LoginAndReg
    },
    computed: {
        activeIndex () {
            return this.$route.path;
        },
    },

};
</script>

<style lang="scss" scoped>
#app_header {
  width: 100%;
  background: #000;
  height: 230px;
  position: relative;
  .bg_img {
    background: url("~@/assets/img/header_bg.jpg") no-repeat;
    background-size: cover;
    height: 180px;
    width: 1500px;
    max-width: 1500px;
    object-fit: fill;
  }
  .nav_tabs_bg {
    height: 50px;
    background: #545c64;
    .nav_tabs {
      height: 100%;
      .el-menu-item,
      .el-submenu {
        height: 100%;
        line-height: 50px;
        font-size: 16px;
      }
    }
    .el-submenu ::v-deep .el-submenu__title {
      height: 100%;
      line-height: 5vh;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: 0;
    }
    @media screen and (max-width: 768px) {
      .el-menu-item {
        padding: 0 13px;
      }
    }
  }
  .login_box {
    position: absolute;
    right: 50px;
    top: calc(9.5vh - 25px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue